export { ConfirmDelete } from 'sections/pp-dashboard-page/confirm-delete/confirm-delete'
